import { useQuery } from "@tanstack/react-query";
import { TEMPLATE_KEYS } from "./template.keys";
import { templateServices } from "./template.services";
import { PaginationParams } from "../type";

export const useGetTemplates = (params?: PaginationParams) => {
  return useQuery({
    queryKey: TEMPLATE_KEYS.GET_TEMPLATES(params),
    queryFn: () => templateServices.getTemplates(params),
  });
};

export const useGetTemplate = (templateId?: string) => {
  return useQuery({
    queryKey: TEMPLATE_KEYS.GET_TEMPLATE(templateId!),
    queryFn: () => templateServices.getTemplate(templateId!),
    enabled: !!templateId,
  });
};

export const useGetRules = (params?: PaginationParams) => {
  return useQuery({
    queryKey: TEMPLATE_KEYS.GET_RULES(params),
    queryFn: () => templateServices.getRules(params),
  });
};

export const useGetRule = (ruleId?: string) => {
  return useQuery({
    queryKey: TEMPLATE_KEYS.GET_RULE(ruleId!),
    queryFn: () => templateServices.getRule(ruleId!),
    enabled: !!ruleId,
  });
};
